export default "__VITE_ASSET__0c4711e1__"